var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgDerm = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  transform: "translate(3.5 6.5)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 17,
  height: 11,
  stroke: "#333",
  strokeWidth: 1.5,
  rx: 0.4
}), /*#__PURE__*/React.createElement("g", {
  fill: "#333",
  transform: "translate(2 6)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 1,
  cy: 1,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  cx: 4.667,
  cy: 1,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  cx: 8.333,
  cy: 1,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  cx: 12,
  cy: 1,
  r: 1
})), /*#__PURE__*/React.createElement("path", {
  stroke: "#333",
  strokeWidth: 1.5,
  d: "M0 3.823c1.426-.43 2.57-.646 3.435-.646 1.296 0 3.14.646 4.807.646 1.667 0 3.88-.646 5.193-.646.875 0 2.034.215 3.477.646"
}))));
export { SvgDerm as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0Ij4KICAgIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0ibm9uemVybyIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMy41IDYuNSkiPgogICAgICAgIDxyZWN0IHdpZHRoPSIxNyIgaGVpZ2h0PSIxMSIgc3Ryb2tlPSIjMzMzIiBzdHJva2Utd2lkdGg9IjEuNSIgcng9Ii40Ii8+CiAgICAgICAgPGcgZmlsbD0iIzMzMyIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMiA2KSI+CiAgICAgICAgICAgIDxjaXJjbGUgY3g9IjEiIGN5PSIxIiByPSIxIi8+CiAgICAgICAgICAgIDxjaXJjbGUgY3g9IjQuNjY3IiBjeT0iMSIgcj0iMSIvPgogICAgICAgICAgICA8Y2lyY2xlIGN4PSI4LjMzMyIgY3k9IjEiIHI9IjEiLz4KICAgICAgICAgICAgPGNpcmNsZSBjeD0iMTIiIGN5PSIxIiByPSIxIi8+CiAgICAgICAgPC9nPgogICAgICAgIDxwYXRoIHN0cm9rZT0iIzMzMyIgc3Ryb2tlLXdpZHRoPSIxLjUiIGQ9Ik0wIDMuODIzYzEuNDI2LS40MyAyLjU3LS42NDYgMy40MzUtLjY0NiAxLjI5NiAwIDMuMTQuNjQ2IDQuODA3LjY0NiAxLjY2NyAwIDMuODgtLjY0NiA1LjE5My0uNjQ2Ljg3NSAwIDIuMDM0LjIxNSAzLjQ3Ny42NDYiLz4KICAgIDwvZz4KPC9zdmc+Cg==";